import { IUserWithClusterOrMachineCenters } from "../MillUserInterfaces";

export enum AddOrEditMode {
    add = "add",
    edit = "edit",
}

export interface IAddOrEditUser {
    user?: IUserWithClusterOrMachineCenters | null;
    open: boolean;
    onClose: () => void;
    onAddUser: () => void;
    onEditUser: () => void;
    clusterAllowed: boolean;
}

export interface IUserMachineCentersByProductionLine {
    [key: string]: number[];
}
export interface IAddOrEditUserFormValues {
    firstname: string;
    lastname: string;
    email: string;
    employeeNumber: string;
    userTypeId: number;
    userMachineCenters: IUserMachineCentersByProductionLine;
    userClusters: number[];
}

export interface IUpsertUserValues {
    user_type_id: number;
    first_name: string;
    last_name: string;
    employee_number: string;
    email: string | null;
    user_machine_centers: {
        data: {
            user_machine_center_id?: number | undefined;
            machine_center_id: number;
            is_enabled: boolean;
        }[];
        on_conflict: {
            constraint: string;
            update_columns: string[];
        };
    };
    mill_id?: number | undefined;
    corporate_id: number;
    user_id?: number | undefined;
    user_clusters?: {
        data: {
            user_cluster_id?: number | undefined;
            cluster_id: number;
            is_enabled: boolean;
        }[];
        on_conflict: {
            constraint: string;
            update_columns: string[];
        };
    };
}
